import { useMutation } from '@tanstack/react-query';
import { LoginApi, SignInTokenPostModel } from '../../../apis/LoginApi/LoginApi.ts';

export function useSendSignInCodeMutation() {
    return useMutation<void, Error, SignInTokenPostModel>({
        mutationFn: (data) => LoginApi.sendSignInCode(data),
    });
}
